/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputChatMessage
 */
export interface InputChatMessage {
    /**
     * 
     * @type {number}
     * @memberof InputChatMessage
     */
    channelId: number;
    /**
     * 
     * @type {string}
     * @memberof InputChatMessage
     */
    content?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof InputChatMessage
     */
    fileIds: Array<number>;
}

/**
 * Check if a given object implements the InputChatMessage interface.
 */
export function instanceOfInputChatMessage(value: object): boolean {
    if (!('channelId' in value)) return false;
    if (!('fileIds' in value)) return false;
    return true;
}

export function InputChatMessageFromJSON(json: any): InputChatMessage {
    return InputChatMessageFromJSONTyped(json, false);
}

export function InputChatMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputChatMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'channelId': json['channelId'],
        'content': json['content'] == null ? undefined : json['content'],
        'fileIds': json['fileIds'],
    };
}

export function InputChatMessageToJSON(value?: InputChatMessage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'channelId': value['channelId'],
        'content': value['content'],
        'fileIds': value['fileIds'],
    };
}

